import { extendObservable } from 'mobx'
import moment from 'moment'
import { currencyApi } from '@atheneum/api'

class CurrencyRatesStore {
  constructor () {
    extendObservable(this, {
      currencyRates: [],
      loading: false,
      month: moment().format('YYYY-MM')
    })
  }

  init () {
    this.getAll()
  }

  getAll = async month => {
    this.loading = true
    return currencyApi.getCurrencyRates(this.month).then(res => {
      this.currencyRates.replace(res)
      this.loading = false
    })
  }

  export = () => currencyApi.exportCurrencyRates(this.month)

  onMonthChange = month => {
    this.month = month.format('YYYY-MM')
    return this.getAll()
  }
}

export default CurrencyRatesStore
